const QUERY_PARAM_PREFIX = 'query-param'

const handleSlug = (type: string, slug: string, anchor?: string) => {
  let path = ''
  switch (type) {
    case 'page':
      path = `/${slug}`
      break
    case 'location':
      path = `/locations/${slug}`
      break
    case 'appointment':
      path = `/services/${slug}`
      break
    case 'service':
      path = `/services/${slug}`
      break
    case 'editorial':
      path = `/article/${slug}`
      break
    case 'team':
      path = `/team/${slug}`
      break
    case 'join':
      path = `/join/${slug}`
      break
    default:
      path = `/${slug}`
  }
  // Add trailing slash if no anchor and path doesn't already have one
  if (!anchor && !path.endsWith('/')) {
    path += '/'
  }

  return anchor ? `${path}#${anchor}` : path
}

/**
 * Builds a complete link URL with optional anchor
 * Handles both relative and absolute URLs
 * @param {string} baseUrl - The base URL (with or without trailing slash)
 * @param {string} [anchor] - Optional anchor/hash to append (without #)
 * @returns {string} Complete URL with anchor if provided
 */
const buildLinkWithAnchor = (baseUrl: string, anchor?: string): string => {
  if (!anchor) return baseUrl

  // Remove trailing slash if present (for clean anchor append)
  const cleanUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

  // Add anchor
  return `${cleanUrl}#${anchor}`
}

const setLatestUrlQueryParams = () => {
  if (window) {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.forEach((value, key) => {
      sessionStorage.setItem(`${QUERY_PARAM_PREFIX}-${key}`, value)
    })
  }
}

const getLatestUrlQueryParams = () => {
  if (window) {
    setLatestUrlQueryParams()

    const queryParams: Record<string, string> = {}

    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith(QUERY_PARAM_PREFIX)) {
        const paramKey = key.replace(`${QUERY_PARAM_PREFIX}-`, '')
        queryParams[paramKey] = sessionStorage.getItem(key) || ''
      }
    })

    return queryParams
  }

  return {}
}

function toPlainText(blocks: any[] = []) {
  return blocks
    ?.map((block: any) => {
      if (block._type !== 'block' || !block.children) {
        return ''
      }
      return block.children?.map((child: any) => child.text).join('')
    })
    .join('\n\n')
}

export {
  handleSlug,
  buildLinkWithAnchor,
  setLatestUrlQueryParams,
  getLatestUrlQueryParams,
  toPlainText,
}
